import BigNumber from 'bignumber.js'

export const get2DayChange = (
  valueNow: number | string,
  value24HoursAgo: number | string,
  value48HoursAgo: number | string,
): [number, number] => {
  // get volume info for both 24 hour periods
  const currentChange = new BigNumber(valueNow).minus(value24HoursAgo).toNumber()
  const previousChange = new BigNumber(value24HoursAgo).minus(value48HoursAgo).toNumber()
  const adjustedPercentChange = new BigNumber(currentChange)
    .minus(previousChange)
    .multipliedBy('100')
    .div(previousChange)
    .toNumber()

  if (new BigNumber(adjustedPercentChange).isNaN() || !new BigNumber(adjustedPercentChange).isFinite()) {
    return [currentChange, 0]
  }
  return [currentChange, adjustedPercentChange]
}

/**
 * get standard percent change between two values
 * @param {*} valueNow
 * @param {*} value24HoursAgo
 */
export const getPercentChange = (valueNow: string | undefined, value24HoursAgo: string | undefined): number => {
  if (valueNow && value24HoursAgo) {
    const change = ((parseFloat(valueNow) - parseFloat(value24HoursAgo)) / parseFloat(value24HoursAgo)) * 100
    if (Number.isFinite(change)) return change
  }
  return 0
}
